import { PRIMARY_JWT_INDEX } from '../const';

export const isPrimaryJWTIndex = (index: number) => index === PRIMARY_JWT_INDEX;
